var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7625 47.635C56.9092 48.0813 56.0292 48.4745 55.1275 48.8125C52.2574 49.8864 49.217 50.4335 46.1525 50.4275C34.3225 50.4275 24.0175 42.29 24.0175 31.8475C24.0326 30.4469 24.4213 29.0758 25.1434 27.8755C25.8654 26.6753 26.8947 25.6896 28.125 25.02C17.425 25.47 14.675 36.62 14.675 43.1525C14.675 61.6225 31.6975 63.495 35.365 63.495C37.3425 63.495 40.325 62.92 42.115 62.355L42.4425 62.245C49.3306 59.8637 55.2028 55.2083 59.0925 49.045C59.2116 48.8573 59.2648 48.6353 59.2437 48.414C59.2225 48.1926 59.1282 47.9847 58.9756 47.823C58.8231 47.6613 58.621 47.555 58.4013 47.5209C58.1816 47.4869 57.9568 47.527 57.7625 47.635Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.7625 47.635C56.9092 48.0813 56.0292 48.4745 55.1275 48.8125C52.2574 49.8864 49.217 50.4335 46.1525 50.4275C34.3225 50.4275 24.0175 42.29 24.0175 31.8475C24.0326 30.4469 24.4213 29.0758 25.1434 27.8755C25.8654 26.6753 26.8947 25.6896 28.125 25.02C17.425 25.47 14.675 36.62 14.675 43.1525C14.675 61.6225 31.6975 63.495 35.365 63.495C37.3425 63.495 40.325 62.92 42.115 62.355L42.4425 62.245C49.3306 59.8637 55.2028 55.2083 59.0925 49.045C59.2116 48.8573 59.2648 48.6353 59.2437 48.414C59.2225 48.1926 59.1282 47.9847 58.9756 47.823C58.8231 47.6613 58.621 47.555 58.4013 47.5209C58.1816 47.4869 57.9568 47.527 57.7625 47.635Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4275 60.3552C24.1977 58.9712 22.2652 57.1577 20.7425 55.0202C19.007 52.6424 17.8127 49.9137 17.2434 47.0254C16.6741 44.1372 16.7436 41.1594 17.4471 38.3009C18.1505 35.4423 19.4708 32.7723 21.3154 30.4781C23.16 28.1839 25.4842 26.321 28.125 25.0202C28.905 24.6527 30.2375 23.9877 32.01 24.0202C33.2588 24.0292 34.4885 24.3274 35.6027 24.8913C36.717 25.4551 37.6856 26.2694 38.4325 27.2702C39.4421 28.6181 39.9987 30.2512 40.0225 31.9352C40.0225 31.8827 46.1375 12.0352 20.0225 12.0352C9.0475 12.0352 0.0225014 22.4502 0.0225014 31.5877C-0.0207888 36.4213 1.01343 41.2038 3.05 45.5877C6.37832 52.6891 12.1986 58.321 19.4057 61.4139C26.6128 64.5068 34.7048 64.8453 42.145 62.3652C39.5399 63.1865 36.7876 63.4331 34.078 63.0878C31.3684 62.7425 28.7659 61.8136 26.45 60.3652L26.4275 60.3552Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M26.4275 60.3552C24.1977 58.9712 22.2652 57.1577 20.7425 55.0202C19.007 52.6424 17.8127 49.9137 17.2434 47.0254C16.6741 44.1372 16.7436 41.1594 17.4471 38.3009C18.1505 35.4423 19.4708 32.7723 21.3154 30.4781C23.16 28.1839 25.4842 26.321 28.125 25.0202C28.905 24.6527 30.2375 23.9877 32.01 24.0202C33.2588 24.0292 34.4885 24.3274 35.6027 24.8913C36.717 25.4551 37.6856 26.2694 38.4325 27.2702C39.4421 28.6181 39.9987 30.2512 40.0225 31.9352C40.0225 31.8827 46.1375 12.0352 20.0225 12.0352C9.0475 12.0352 0.0225014 22.4502 0.0225014 31.5877C-0.0207888 36.4213 1.01343 41.2038 3.05 45.5877C6.37832 52.6891 12.1986 58.321 19.4057 61.4139C26.6128 64.5068 34.7048 64.8453 42.145 62.3652C39.5399 63.1865 36.7876 63.4331 34.078 63.0878C31.3684 62.7425 28.7659 61.8136 26.45 60.3652L26.4275 60.3552Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0775 37.215C37.875 37.4775 37.2525 37.84 37.2525 38.63C37.2525 39.2825 37.6775 39.91 38.4325 40.4375C42.0275 42.9375 48.805 42.6075 48.8225 42.6075C51.4863 42.6011 54.0996 41.8802 56.39 40.52C58.7005 39.1709 60.6181 37.2411 61.9526 34.9221C63.2871 32.6031 63.992 29.9755 63.9975 27.3C64.0625 21.6975 61.9975 17.9725 61.1625 16.3225C55.865 5.96 44.43 1.56661e-07 31.995 1.56661e-07C23.5855 -0.000831393 15.5136 3.30875 9.5252 9.21293C3.5368 15.1171 0.11325 23.1413 -0.0050087 31.55C0.114991 22.415 9.19499 15.0375 19.995 15.0375C20.87 15.0375 25.86 15.1225 30.495 17.555C34.58 19.7 36.72 22.29 38.2075 24.8575C39.7525 27.525 40.0275 30.895 40.0275 32.2375C40.0275 33.58 39.3425 35.57 38.0775 37.215Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0775 37.215C37.875 37.4775 37.2525 37.84 37.2525 38.63C37.2525 39.2825 37.6775 39.91 38.4325 40.4375C42.0275 42.9375 48.805 42.6075 48.8225 42.6075C51.4863 42.6011 54.0996 41.8802 56.39 40.52C58.7005 39.1709 60.6181 37.2411 61.9526 34.9221C63.2871 32.6031 63.992 29.9755 63.9975 27.3C64.0625 21.6975 61.9975 17.9725 61.1625 16.3225C55.865 5.96 44.43 1.56661e-07 31.995 1.56661e-07C23.5855 -0.000831393 15.5136 3.30875 9.5252 9.21293C3.5368 15.1171 0.11325 23.1413 -0.0050087 31.55C0.114991 22.415 9.19499 15.0375 19.995 15.0375C20.87 15.0375 25.86 15.1225 30.495 17.555C34.58 19.7 36.72 22.29 38.2075 24.8575C39.7525 27.525 40.0275 30.895 40.0275 32.2375C40.0275 33.58 39.3425 35.57 38.0775 37.215Z",
    fill: "url(#paint5_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.675,
    y1: 44.2625,
    x2: 59.26,
    y2: 44.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3 44.6139) scale(23.845 22.6527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 38.18,
    y1: 24.9227,
    x2: 10.3325,
    y2: 55.2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6436 49.7522) rotate(-81.3844) scale(35.8565 28.9685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.46061 11.8442) rotate(92.2906) scale(50.648 107.87)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.013 19.3515) rotate(73.7398) scale(24.335 19.7892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.57c2d4fe.svg";
export { ForwardRef as ReactComponent };